<template>
    <div class="form-group">
        <label :for="name">{{label}}</label>
    </div>
</template>

<script>
    export default {
        props: {
            label: {
                type: String,
                required: true
            },

            name: {
                type: String,
                required: true
            }
        }
    };

</script>

<style>
</style>
